const HOST = `https://api.parser.arbitrkit.ru`;
export default HOST;
